import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import userReducer from "../features/dashboard/userSlice";
import tradeReducer from "../features/dashboard/tradeSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    trade: tradeReducer,
    user: userReducer,
  },
  // optional: if you're not adding custom middleware, you can even omit the middleware key
});
